function notFound () {
  return (
    <div>Not Found</div>
    );
}

export default notFound;